import * as services from './intents.queries';

export default services;
